export default "__VITE_ASSET__C_NxzRk4__"